import React from 'react';

import DashboardLayout from 'layouts/Dashboard/Dashboard';

export const withDashboard =
  <T,>(Component: React.ComponentType<T>) =>
  (props: T): JSX.Element =>
    (
      <DashboardLayout>
        <Component {...props} />
      </DashboardLayout>
    );
